import Vue from 'vue';

import './core/lazy_use';
import App from './App.vue';
import router from './router';
import store from './store';
import './permission';
import serverconfig from '@/api/server.config';
import { getClientToken } from '@/api/user';

import myxss from '@/utils/xss';
Vue.prototype.$xss = (val) => {
  return myxss.process(val);
}

import { getWxApplets } from '@/plugins/auth';
Vue.config.productionTip = false;
Vue.prototype.$getWxApplets = getWxApplets;
Vue.config.ignoredElements = ['wx-open-launch-weapp'];
Vue.use(require('vue-wechat-title'))

// 启动前先通过接口获取全局 token，写入 serverconfig.CLIENT_TOKEN（替代原 VUE_APP_CLIENT_TOKEN 配置）
async function bootstrap() {
  try {
    const res = await getClientToken();
    serverconfig.CLIENT_TOKEN = res && res.resultData || '';
  } catch (e) {
    console.error('获取 CLIENT_TOKEN 失败：', e);
  }
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app');
}
bootstrap();
